import {ElementNode, LexicalNode, LineBreakNode, TextNode} from 'lexical';

const TAG_REGEX = /<<.*?>>|&lt;&lt;.*?&gt;&gt;/g;
const PLACEHOLDER = (index: number) => `<<...${index}>>`;

/**
 * Extracts special tags from the HTML and replaces them with indexed placeholders.
 */
export const extractSpecialTags = (html: string): {cleanedHtml: string; tagMap: string[]} => {
    const tagMap: string[] = [];

    const cleanedHtml = html.replace(TAG_REGEX, tag => {
        const index = tagMap.length;
        tagMap.push(tag);

        return PLACEHOLDER(index);
    });

    return {cleanedHtml, tagMap};
};

/**
 * Restores original tags from placeholders in the HTML response.
 */
export const restoreSpecialTags = (html: string, tagMap: string[]): string => {
    let restoredHtml = html;

    tagMap.forEach((tag, index) => {
        const placeholder = PLACEHOLDER(index);
        const replacement = tag;

        const regex = new RegExp(placeholder, 'g');
        restoredHtml = restoredHtml.replace(regex, replacement);
    });

    // Remove unmatched placeholders just in case
    restoredHtml = restoredHtml.replace(/<<\.{3}\d+>>/g, '');

    return restoredHtml;
};

export function isNodeEmpty(node: LexicalNode): boolean {
    if (node instanceof TextNode) return node.getTextContent().trim() === '';

    if (node instanceof LineBreakNode) return true;

    if (node instanceof ElementNode) {
        const children = node.getChildren();
        if (children.length === 0) return true;

        return children.every(child => isNodeEmpty(child));
    }

    // Any other node type (e.g. decorator/image) → not empty
    return false;
}
